import './App.css';
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import Programme from "./components/FirstMay";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/programme-1-mai" element={<Programme />} />
                {/* Toutes les autres routes sont redirigées vers programme-1-mai */}
                <Route path="*" element={<Navigate to="/programme-1-mai" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;